import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function WhyEmprendeSection() {
  return <section className="py-20 bg-white" data-id="element-137">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-slate-900 mb-6" data-id="element-140">
            ¿Por qué cada vez más personas están emprendiendo en internet?
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-141">
            Internet abrió una oportunidad enorme para quienes quieren generar
            ingresos propios.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-slate-50 rounded-3xl p-8 md:p-12 shadow-soft border border-slate-100" data-id="element-142">
          <p className="text-lg text-slate-700 mb-8 font-medium" data-id="element-143">
            Cada vez más personas están descubriendo que pueden:
          </p>

          <ul className="space-y-4 mb-10" data-id="element-144">
            {['Vender su conocimiento', 'Crear un servicio online', 'Iniciar un negocio digital', 'Generar ingresos extra desde su casa'].map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4 + index * 0.1
          }} className="flex items-center text-lg text-slate-700" data-id="element-145">
                <CheckCircle2Icon className="w-6 h-6 text-brand-green mr-3 flex-shrink-0" data-id="element-146" />
                {item}
              </motion.li>)}
          </ul>

          <div className="bg-white p-6 rounded-2xl border-l-4 border-brand-blue shadow-sm" data-id="element-147">
            <p className="text-lg text-slate-700 mb-2" data-id="element-148">
              Pero el problema es que{' '}
              <span className="font-bold" data-id="element-149">
                nadie nos enseña cómo empezar correctamente.
              </span>
            </p>
            <p className="text-xl font-heading font-bold text-brand-blue" data-id="element-150">
              Ahí es donde entra Emprende Digital.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}